export const formFields = [
  {
    section: "Price Schedule (hidden)",
    name: "prcPriceScheduleName",
    label: "Price Schedule",
    fieldLabel: "PRC Price Schedule Name",
    type: "text",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [4, 18],
  },
  {
    section: "Price Schedule (hidden)",
    name: "prcPriceScheduleDesc",
    label: "Description",
    fieldLabel: "PRC Price Schedule Desc",
    type: "text",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: {
        value: 25,
        message: "Cannot exceed more than 25 characters",
      },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [5, 36],
  },
  {
    section: "Price Schedule (hidden)",
    name: "psxDisplayRecord",
    label: "Display",
    fieldLabel: "ADX Display Record",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: {
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [5, 73],
  },
  {
    section: "Price Schedule (hidden)",
    name: "prcPaySalesTax",
    label: "Sales Tax",
    fieldLabel: "PRC Pay Sales Tax",
    type: "dropdown",
    dropdownCondition: "Valid Values",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 28],
  },
  {
    section: "Price Schedule (hidden)",
    name: "prcAllowZeroSbmCost",
    label: "Allow $0.00 Sbm Cost",
    fieldLabel: "PRC Allow Zero Sbm Cost",
    type: "dropdown",
    dropdownCondition: "Yes Or No",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 28],
  },
  {
    section: "Price Schedule (hidden)",
    name: "prcAwpEdit",
    label: "AWP Edit",
    fieldLabel: "PRC AWP Edit",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [11, 28],
  },
  {
    section: "Price Schedule (hidden)",
    name: "prcBasisReimbDeterOvr",
    label: "Reimbursement Basis Override",
    fieldLabel: "PRC Basis Reimb Deter Ovr",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      maxLength: { value: 2, message: "Cannot exceed more than 2 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [13, 32],
  },
  {
    section: "Multiple-Ingredient Compound Pricing",
    name: "prcMultiIngSource",
    label: "Source",
    fieldLabel: "PRC Multi-Ing Source",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 28],
  },
  {
    section: "Multiple-Ingredient Compound Pricing",
    name: "prcMultiIngPscSeq",
    label: "Seq",
    fieldLabel: "PRC Multi-Ing PSC Seq#",
    type: "number",
    options: {
      maxLength: { value: 3, message: "Cannot exceed more than 3 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [16, 31],
  },
  {
    section: "Multiple-Ingredient Compound Pricing",
    name: "prcMultiIngDispFeeFlg",
    label: "Dispensing Fee",
    fieldLabel: "PRC Multi-Ing DispFee Flg",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 28],
  },
  {
    section: "Multiple-Ingredient Compound Pricing",
    name: "prcMultiIngPrfSrvFlg",
    label: "Professional Service Fee",
    fieldLabel: "PRC Multi-Ing Prf Srv Flg",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {
      required: { value: true, message: "Value required" },
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 28],
  },
  {
    section: "Audit Fields (hidden)",
    name: "addDate",
    label: "Added:",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 20],
  },
  {
    section: "Audit Fields (hidden)",
    name: "chgDate",
    label: "Changed:",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 32],
  },
  {
    section: "Audit Fields (hidden)",
    name: "chgUserName",
    label: "User:",
    fieldLabel: "CHG User Name",
    type: "text",
    options: {
      maxLength: {
        value: 10,
        message: "Cannot exceed more than 10 characters",
      },
    },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 57],
  },
  {
    section: "Audit Fields (hidden)",
    name: "noteExistenceStatus",
    label: "Note Exist:",
    fieldLabel: "Note Existence Status",
    type: "text",
    options: {
      maxLength: { value: 1, message: "Cannot exceed more than 1 characters" },
    },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [20, 79],
  },
];
